export const LANGS = [
  { code: "it", label: "IT" },
  { code: "en", label: "EN" },
  { code: "fr", label: "FR" },
];

export const T = {
  /* ============================== ITALIANO ============================== */
  it: {
    nav: {
      home: "Home",
      servizi: "Servizi",
      team: "Il Team",
      contatti: "Contatti",
      cta: "Parla con noi",
    },
    home: {
      eyebrow: "Consulenza bilaterale Italia–Marocco",
      titleLines: ["Costruiamo il ponte", "fra Italia e Marocco"],
      sub: "SWM Consulting è la società di consulenza che connette Italia e Marocco. Fondata da professionisti italo-marocchini, accompagna imprese e investitori nei due paesi con competenze interculturali, conoscenza dei territori e una rete di relazioni affidabile.",
      ctaPrimary: "Scopri i servizi",
      ctaSecondary: "Parla con noi",
      corridorLabel: "Il corridoio",
      corridorFrom: "Italia",
      corridorTo: "Marocco",
      corridorNote: "Relazioni, investimenti, progetti.",
      scrollHint: "Scorri",
      stats: [
        { n: "3", kw: "soci", l: "soci fondatori italo-marocchini" },
        { n: "4", kw: "lingue", l: "lingue di lavoro: italiano, arabo, francese, inglese" },
        { n: "2", kw: "paesi uniti", l: "paesi uniti da un unico ponte: Italia e Marocco" },
        { n: "1", kw: "obiettivo", l: "obiettivo: la relazione fra i due paesi" },
      ],
      marquee: [
        "Italia",
        "المغرب",
        "Marocco",
        "Investimenti",
        "Relazioni",
        "Internazionalizzazione",
        "Opportunità",
        "Comunità",
      ],
      mission: {
        eyebrow: "Missione",
        title: "Aiutiamo le imprese a crescere fra Italia e Marocco.",
        text: "Accompagniamo le imprese nei processi di espansione, favorendo lo sviluppo di collaborazioni strategiche, investimenti produttivi e scambi commerciali tra i due paesi. Operiamo come facilitatori di internazionalizzazione, mettendo a disposizione competenze interculturali, conoscenza dei territori e una rete di relazioni affidabile.",
      },
      vision: {
        eyebrow: "Visione",
        title: "Il ponte su cui viaggiano idee, investimenti e progetti.",
        text: "Contribuire allo sviluppo economico e sociale del Marocco, favorendo sinergie che non solo rafforzano il tessuto locale, ma offrono nuove opportunità di crescita all'imprenditoria italiana.",
      },
      twoLands: {
        eyebrow: "Due terre, una rete",
        title: "Non visitiamo i due paesi: li abitiamo.",
        text: "Viviamo e lavoriamo sui due lati del Mediterraneo: dentro le istituzioni, le associazioni e le comunità italo-marocchine. È da qui che nascono le relazioni che durano.",
        captionIta: "Italia",
        captionMar: "Marocco",
      },
      servicesPreview: {
        eyebrow: "Cosa facciamo",
        title: "Servizi pensati per valicare i confini.",
        link: "Tutti i servizi",
        items: [
          {
            title: "Internazionalizzazione & Market Entry",
            short: "Ingresso nel mercato, scouting di partner e supporto operativo nel paese di destinazione.",
          },
          {
            title: "Investor Relations",
            short: "Mettiamo in relazione capitali e progetti nei due sensi, con follow-up costante.",
          },
          {
            title: "Relazioni istituzionali & Networking",
            short: "Istituzioni, associazioni e comunità: la rete che apre le porte giuste.",
          },
          {
            title: "Comunicazione, Branding & Digitale",
            short: "Identità, fiere, incontri aziendali e presenza digitale per crescere nei due mercati.",
          },
        ],
      },
      teamPreview: {
        eyebrow: "Il team",
        title: "Tre figure, un unico ponte.",
        link: "Scopri il team",
        text: "Tre soci, una sola missione: essere sul campo, da entrambi i lati del Mediterraneo.",
      },
      data: {
        eyebrow: "Perché Italia e Marocco",
        title: "Due paesi che hanno tutto l'interesse a guardarsi.",
        text: "Il know-how e il design italiani incontrano la crescita industriale marocchina e la sua posizione di porta verso i mercati africani. I numeri parlano chiaro.",
        items: [
          { n: 5, suffix: " mld €", l: "di scambi commerciali fra i due paesi (2024)" },
          { n: 1, suffix: "°", l: "esportatore di automobili in Africa: il Marocco" },
          { n: 2, suffix: "°", l: "economia dell'Unione Europea: l'Italia" },
          { n: 200, suffix: "+", l: "imprese italiane già attive in Marocco, con oltre 13.800 addetti" },
          { n: 59, suffix: " mln", l: "di consumatori in Italia" },
          { n: 38, suffix: " mln", l: "di consumatori in Marocco" },
        ],
        source: "Fonti: Osservatorio economico MAECI — dati ICE e Banca d'Italia (2024) · SACE",
      },
      map: {
        eyebrow: "Il corridoio",
        title: "Due paesi, un solo corridoio.",
        text: "La rete in Italia incontra la sede in Marocco: un corridoio unico per relazioni, investimenti e progetti.",
        labelIta: "Italia",
        labelMar: "Marocco",
        legendIta: "Rete in Italia",
        legendMar: "Sede in Marocco",
      },
      cta: {
        title: "Pronti ad attraversare il ponte?",
        text: "Raccontaci il tuo progetto: costruiamo insieme la rotta fra Italia e Marocco.",
        btn: "Vai ai contatti",
      },
    },
    services: {
      eyebrow: "Servizi",
      title: "Dalla prima telefonata al primo progetto.",
      sub: "Cinque linee di servizio, un solo metodo: mettiamo sul tavolo le persone giuste, nei due paesi.",
      items: [
        {
          title: "Internazionalizzazione & Market Entry",
          desc: "Accompagniamo le imprese nei processi di espansione verso l'altro paese: analisi delle opportunità, primo contatto con il mercato, scouting di partner e fornitori, supporto operativo sul campo fino alla stabilizzazione.",
        },
        {
          title: "Investor Relations",
          desc: "Supporto agli investitori italiani interessati al Marocco e ai soggetti marocchini che puntano all'Italia: presentazione di opportunità produttive, incontri con i protagonisti giusti e follow-up costante delle trattative.",
        },
        {
          title: "Relazioni istituzionali & Networking",
          desc: "Grazie ai ruoli istituzionali e associativi dei soci nei due paesi, apriamo le porte giuste e costruiamo alleanze stabili fra i due sistemi paese.",
        },
        {
          title: "Comunicazione, Branding & Digitale",
          desc: "Brand identity, comunicazione interculturale, organizzazione di meeting aziendali e fiere internazionali, siti web e strumenti digitali sviluppati su misura per crescere nei due mercati.",
        },
        {
          title: "Mediazione interculturale & Community",
          desc: "Eventi, progetti di territorio, turismo e relazioni pubbliche: il dialogo fra le comunità italiane e marocchine prima, e insieme, ai contratti. Le persone sono il primo asset di ogni investimento.",
        },
      ],
      process: {
        eyebrow: "Come lavoriamo",
        title: "Un metodo in quattro passi.",
        steps: [
          { n: "01", title: "Ascolto", desc: "Obiettivi, tempi e vincoli del tuo progetto: partiamo da dove sei." },
          { n: "02", title: "Analisi", desc: "Opportunità, contatti e territorio: costruiamo la mappa delle possibilità." },
          { n: "03", title: "Matching", desc: "Mettiamo in relazione le persone giuste, nei due paesi." },
          { n: "04", title: "Accompagnamento", desc: "Restiamo sul campo, fino ai risultati e oltre." },
        ],
      },
      note: "Ogni progetto è diverso: le linee di servizio si combinano su misura.",
      cta: "Discutiamo il tuo progetto",
    },
    team: {
      eyebrow: "Il team",
      title: "Tre figure, un unico ponte.",
      sub: "Professionisti italo-marocchini attivi in Italia e in Marocco, con ruoli nelle istituzioni e nelle associazioni dei due paesi.",
      labels: {
        education: "Formazione",
        civic: "Impegno istituzionale e associativo",
        languages: "Lingue",
        skills: "Competenze chiave",
      },
      founders: [
        {
          id: "mohammed",
          initials: "MH",
          name: "Mohammed Hammouch",
          role: "Community Manager",
          bio: "Consulente strategico nel settore dell'energia e amministratore locale impegnato nello sviluppo del territorio e nel dialogo interculturale. Nato nel 1990, professionista freelance con esperienza nella consulenza energetica e nei servizi multipli.",
          education: "Diploma in Sistemi Energetici e Rinnovabili",
          civic: [
            "Presidente dell'associazione GIM — Giovani Italo-Marocchini, associazione che ha costruito solide connessioni istituzionali e culturali fra Italia e Marocco",
            "Assessore al Turismo, Commercio e Ambiente — Comune di Pieve di Soligo (TV)",
          ],
          languages: ["Italiano", "Arabo", "Francese", "Inglese"],
        },
        {
          id: "sana",
          initials: "SE",
          name: "Sana Ed Dami",
          role: "Investor Relations",
          bio: "Professionista della comunicazione e del branding con background multiculturale e nove anni di esperienza in azienda. Esperta nell'organizzazione di meeting aziendali e fiere internazionali: dal 2024 è storyteller ufficiale UNESCO per il sito del Patrimonio Mondiale delle Colline del Prosecco di Conegliano e Valdobbiadene.",
          education: "Laurea in Scienze Politiche, Relazioni Internazionali e Diritti Umani — Università di Padova · Erasmus, University of Reading (UK)",
          civic: [
            "Consigliera comunale e Capogruppo — Farra di Soligo (TV)",
            "Candidata alla carica di Sindaco nel 2024",
          ],
          languages: ["Italiano", "Arabo", "Inglese", "Francese"],
        },
        {
          id: "wissam",
          initials: "WA",
          name: "Wissam El Aissaoui",
          role: "Morocco Relations",
          bio: "Web designer e facilitatore di opportunità fra Italia e Marocco. Nato nel 1998, professionista freelance nella comunicazione digitale e nello sviluppo web, fondatore di WEA Solution. Co-fondatore di SWM Consulting: supporta imprenditori e investitori italiani nel processo di internazionalizzazione in Marocco.",
          education: "Diploma commerciale · Post-diploma biennale in marketing turistico",
          civic: [
            "Consigliere comunale — Poviglio (RE)",
            "Vicepresidente dell'associazione GIM",
            "Presidente CNA Giovani Imprenditori Reggio Emilia",
            "Presidente RNI Young Italy — sezione giovanile del partito marocchino RNI",
          ],
          languages: ["Italiano", "Arabo", "Francese", "Inglese"],
        },
      ],
    },
    contact: {
      eyebrow: "Contatti",
      title: "Parliamo del tuo progetto.",
      sub: "Un dubbio, un'opportunità, un progetto fra i due paesi? Scrivici: rispondiamo in italiano, arabo, francese e inglese.",
      cards: [
        { label: "Email", value: "info@swmconsulting.it", href: "mailto:info@swmconsulting.it" },
        { label: "Sedi", value: "Rabat (Marocco) · Reggio Emilia e Treviso (Italia)" },
      ],
      form: {
        title: "Scrivici",
        name: "Nome e cognome",
        namePlaceholder: "Mario Rossi",
        email: "Email",
        emailPlaceholder: "nome@azienda.it",
        org: "Organizzazione (facoltativo)",
        orgPlaceholder: "Azienda / Studio / Associazione",
        interest: "Interesse",
        interestOptions: [
          "Internazionalizzazione & Market Entry",
          "Investor Relations",
          "Relazioni istituzionali & Networking",
          "Comunicazione, Branding & Digitale",
          "Mediazione interculturale & Community",
          "Altro",
        ],
        message: "Messaggio",
        messagePlaceholder: "Raccontaci in breve il tuo progetto…",
        submit: "Invia messaggio",
        sending: "Invio…",
        success: "Messaggio inviato! Ti risponderemo presto.",
        error: "Errore nell'invio. Riprova.",
        required: "campi obbligatori",
      },
    },
    footer: {
      tagline: "Connecting Italy with Morocco",
      blurb: "Consulenza per le relazioni e gli investimenti fra Italia e Marocco.",
      browse: "Naviga",
      contact: "Contatti",
      rights: "© SWM Consulting. Tutti i diritti riservati.",
    },
  },

  /* ============================== ENGLISH ============================== */
  en: {
    nav: {
      home: "Home",
      servizi: "Services",
      team: "The Team",
      contatti: "Contact",
      cta: "Talk to us",
    },
    home: {
      eyebrow: "Italy–Morocco bilateral consultancy",
      titleLines: ["Building the bridge", "between Italy and Morocco"],
      sub: "SWM Consulting is the consultancy firm that connects Italy and Morocco. Founded by Italian-Moroccan professionals, it guides companies and investors in both countries with intercultural skills, territorial knowledge and a reliable network of relationships.",
      ctaPrimary: "Explore our services",
      ctaSecondary: "Talk to us",
      corridorLabel: "The corridor",
      corridorFrom: "Italy",
      corridorTo: "Morocco",
      corridorNote: "Relations, investments, projects.",
      scrollHint: "Scroll",
      stats: [
        { n: "3", kw: "founding partners", l: "Italian-Moroccan founding partners" },
        { n: "4", kw: "working languages", l: "working languages: Italian, Arabic, French, English" },
        { n: "2", kw: "countries", l: "countries joined by a single bridge: Italy and Morocco" },
        { n: "1", kw: "goal", l: "goal: the relationship between the two countries" },
      ],
      marquee: [
        "Italy",
        "المغرب",
        "Morocco",
        "Investments",
        "Relations",
        "Internationalization",
        "Opportunities",
        "Community",
      ],
      mission: {
        eyebrow: "Mission",
        title: "We help businesses grow between Italy and Morocco.",
        text: "We accompany companies through their expansion processes, fostering strategic collaborations, productive investments and commercial exchanges between the two countries. We operate as internationalization facilitators, providing intercultural skills, knowledge of the territories and a reliable network of relationships.",
      },
      vision: {
        eyebrow: "Vision",
        title: "The bridge where ideas, investments and projects travel.",
        text: "To contribute to the economic and social development of Morocco, fostering synergies that both strengthen the local fabric and open new growth opportunities to Italian entrepreneurship.",
      },
      twoLands: {
        eyebrow: "Two lands, one network",
        title: "We don't visit the two countries: we live them.",
        text: "We live and work on both sides of the Mediterranean: inside institutions, associations and the Italian-Moroccan communities. That is where lasting relationships come from.",
        captionIta: "Italy",
        captionMar: "Morocco",
      },
      servicesPreview: {
        eyebrow: "What we do",
        title: "Services built to cross borders.",
        link: "All services",
        items: [
          {
            title: "Internationalization & Market Entry",
            short: "Market entry, partner scouting and on-the-ground operational support.",
          },
          {
            title: "Investor Relations",
            short: "We connect capital and projects in both directions, with constant follow-up.",
          },
          {
            title: "Institutional relations & Networking",
            short: "Institutions, associations and communities: the network that opens the right doors.",
          },
          {
            title: "Communication, Branding & Digital",
            short: "Identity, trade fairs, corporate meetings and digital presence for the two markets.",
          },
        ],
      },
      teamPreview: {
        eyebrow: "The team",
        title: "Three people, one bridge.",
        link: "Meet the team",
        text: "Three partners, one mission: being on the ground, on both sides of the Mediterranean.",
      },
      data: {
        eyebrow: "Why Italy and Morocco",
        title: "Two countries with every reason to look at each other.",
        text: "Italian know-how and design meet Moroccan industrial growth and its position as a gateway to African markets. The numbers speak for themselves.",
        items: [
          { n: 5, suffix: " bn €", l: "in trade between the two countries (2024)" },
          { n: 1, suffix: "st", l: "car exporter in Africa: Morocco" },
          { n: 2, suffix: "nd", l: "largest economy in the European Union: Italy" },
          { n: 200, suffix: "+", l: "Italian companies already operating in Morocco, employing over 13,800 people" },
          { n: 59, suffix: " mln", l: "consumers in Italy" },
          { n: 38, suffix: " mln", l: "consumers in Morocco" },
        ],
        source: "Sources: MAECI economic observatory — ICE and Bank of Italy data (2024) · SACE",
      },
      map: {
        eyebrow: "The corridor",
        title: "Two countries, one corridor.",
        text: "The network in Italy meets the head office in Morocco: one unique corridor for relations, investments and projects.",
        labelIta: "Italy",
        labelMar: "Morocco",
        legendIta: "Network in Italy",
        legendMar: "Head office in Morocco",
      },
      cta: {
        title: "Ready to cross the bridge?",
        text: "Tell us about your project: together we chart the route between Italy and Morocco.",
        btn: "Go to contact",
      },
    },
    services: {
      eyebrow: "Services",
      title: "From first phone call to first project.",
      sub: "Five service lines, one method: we bring the right people to the table, in both countries.",
      items: [
        {
          title: "Internationalization & Market Entry",
          desc: "We accompany companies through their expansion process into the other country: opportunity analysis, first market contact, scouting of partners and suppliers, on-the-ground operational support until things are stable.",
        },
        {
          title: "Investor Relations",
          desc: "Support for Italian investors interested in Morocco and Moroccan players aiming at Italy: presentation of productive opportunities, meetings with the right counterparts and constant follow-up on negotiations.",
        },
        {
          title: "Institutional relations & Networking",
          desc: "Thanks to the partners' institutional and associative roles in both countries, we open the right doors and build stable alliances between the two country systems.",
        },
        {
          title: "Communication, Branding & Digital",
          desc: "Brand identity, intercultural communication, corporate meetings and international trade fairs, websites and digital tools built to grow in both markets.",
        },
        {
          title: "Intercultural mediation & Community",
          desc: "Events, territorial projects, tourism and public relations: dialogue between Italian and Moroccan communities first — and together with — the contracts. People are the first asset of every investment.",
        },
      ],
      process: {
        eyebrow: "How we work",
        title: "A four-step method.",
        steps: [
          { n: "01", title: "Listening", desc: "Goals, timelines and constraints of your project: we start from where you are." },
          { n: "02", title: "Analysis", desc: "Opportunities, contacts and territory: we map out the possibilities." },
          { n: "03", title: "Matching", desc: "We connect the right people, in both countries." },
          { n: "04", title: "Guidance", desc: "We stay on the ground, until results — and beyond." },
        ],
      },
      note: "Every project is different: service lines combine on a bespoke basis.",
      cta: "Let's discuss your project",
    },
    team: {
      eyebrow: "The team",
      title: "Three people, one bridge.",
      sub: "Italian-Moroccan professionals active in Italy and Morocco, holding roles in institutions and associations in both countries.",
      labels: {
        education: "Education",
        civic: "Institutional & associative engagement",
        languages: "Languages",
        skills: "Key skills",
      },
      founders: [
        {
          id: "mohammed",
          initials: "MH",
          name: "Mohammed Hammouch",
          role: "Community Manager",
          bio: "Strategic consultant in the energy sector and local administrator committed to territorial development and intercultural dialogue. Born in 1990, freelance professional with experience in energy and multi-service consulting.",
          education: "Diploma in Energy and Renewable Systems",
          civic: [
            "President of the association GIM — Giovani Italo-Marocchini, an association that has built solid institutional and cultural connections between Italy and Morocco",
            "Assessor for Tourism, Commerce and Environment — Municipality of Pieve di Soligo (TV)",
          ],
          languages: ["Italian", "Arabic", "French", "English"],
        },
        {
          id: "sana",
          initials: "SE",
          name: "Sana Ed Dami",
          role: "Investor Relations",
          bio: "Communication and branding professional with a multicultural background and nine years of corporate experience. Expert in organizing corporate meetings and international trade fairs; since 2024, official UNESCO storyteller for the World Heritage site of the Prosecco Hills of Conegliano and Valdobbiadene.",
          education: "Degree in Political Science, International Relations and Human Rights — University of Padua · Erasmus, University of Reading (UK)",
          civic: [
            "Municipal councillor and group leader — Farra di Soligo (TV)",
            "Candidate for Mayor in 2024",
          ],
          languages: ["Italian", "Arabic", "English", "French"],
        },
        {
          id: "wissam",
          initials: "WA",
          name: "Wissam El Aissaoui",
          role: "Morocco Relations",
          bio: "Web designer and facilitator of opportunities between Italy and Morocco. Born in 1998, freelance professional in digital communication and web development, founder of WEA Solution. Co-founder of SWM Consulting: he supports Italian entrepreneurs and investors in the internationalization process in Morocco.",
          education: "Commercial diploma · Two-year post-diploma in tourism marketing",
          civic: [
            "Municipal councillor — Poviglio (RE)",
            "Vice-President of the association GIM",
            "President of CNA Young Entrepreneurs Reggio Emilia",
            "President of RNI Young Italy — youth section of the Moroccan RNI party",
          ],
          languages: ["Italian", "Arabic", "French", "English"],
        },
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "Let's talk about your project.",
      sub: "A doubt, an opportunity, a project between the two countries? Write to us: we reply in Italian, Arabic, French and English.",
      cards: [
        { label: "Email", value: "info@swmconsulting.it", href: "mailto:info@swmconsulting.it" },
        { label: "Offices", value: "Rabat (Morocco) · Reggio Emilia and Treviso (Italy)" },
      ],
      form: {
        title: "Write to us",
        name: "Full name",
        namePlaceholder: "John Smith",
        email: "Email",
        emailPlaceholder: "name@company.com",
        org: "Organization (optional)",
        orgPlaceholder: "Company / Firm / Association",
        interest: "Interest",
        interestOptions: [
          "Internationalization & Market Entry",
          "Investor Relations",
          "Institutional relations & Networking",
          "Communication, Branding & Digital",
          "Intercultural mediation & Community",
          "Other",
        ],
        message: "Message",
        messagePlaceholder: "Tell us briefly about your project…",
        submit: "Send message",
        sending: "Sending…",
        success: "Message sent! We'll get back to you soon.",
        error: "Error while sending. Please try again.",
        required: "required fields",
      },
    },
    footer: {
      tagline: "Connecting Italy with Morocco",
      blurb: "Consulting for relations and investments between Italy and Morocco.",
      browse: "Browse",
      contact: "Contact",
      rights: "© SWM Consulting. All rights reserved.",
    },
  },

  /* ============================== FRANÇAIS ============================== */
  fr: {
    nav: {
      home: "Accueil",
      servizi: "Services",
      team: "L'Équipe",
      contatti: "Contact",
      cta: "Parlons-en",
    },
    home: {
      eyebrow: "Conseil bilatéral Italie–Maroc",
      titleLines: ["Bâtir le pont", "entre l'Italie et le Maroc"],
      sub: "SWM Consulting est le cabinet de conseil qui relie l'Italie et le Maroc. Fondé par des professionnels italo-marocains, il accompagne entreprises et investisseurs dans les deux pays, avec des compétences interculturelles, la connaissance des territoires et un réseau de relations fiable.",
      ctaPrimary: "Découvrir nos services",
      ctaSecondary: "Parlons-en",
      corridorLabel: "Le corridor",
      corridorFrom: "Italie",
      corridorTo: "Maroc",
      corridorNote: "Relations, investissements, projets.",
      scrollHint: "Défiler",
      stats: [
        { n: "3", kw: "associés fondateurs", l: "associés fondateurs italo-marocains" },
        { n: "4", kw: "langues de travail", l: "langues de travail : italien, arabe, français, anglais" },
        { n: "2", kw: "pays", l: "pays unis par un seul pont : l'Italie et le Maroc" },
        { n: "1", kw: "objectif", l: "objectif : la relation entre les deux pays" },
      ],
      marquee: [
        "Italie",
        "المغرب",
        "Maroc",
        "Investissements",
        "Relations",
        "Internationalisation",
        "Opportunités",
        "Communauté",
      ],
      mission: {
        eyebrow: "Mission",
        title: "Nous aidons les entreprises à grandir entre l'Italie et le Maroc.",
        text: "Nous accompagnons les entreprises dans leurs processus d'expansion, en favorisant les collaborations stratégiques, les investissements productifs et les échanges commerciaux entre les deux pays. Nous opérons comme facilitateurs d'internationalisation, en mettant à disposition des compétences interculturelles, la connaissance des territoires et un réseau de relations fiable.",
      },
      vision: {
        eyebrow: "Vision",
        title: "Le pont sur lequel voyagent idées, investissements et projets.",
        text: "Contribuer au développement économique et social du Maroc, en favorisant des synergies qui renforcent le tissu local tout en offrant de nouvelles opportunités de croissance à l'entrepreneuriat italien.",
      },
      twoLands: {
        eyebrow: "Deux terres, un réseau",
        title: "Nous ne visitons pas les deux pays : nous les habitons.",
        text: "Nous vivons et travaillons des deux côtés de la Méditerranée : au cœur des institutions, des associations et des communautés italo-marocaines. C'est de là que naissent les relations qui durent.",
        captionIta: "Italie",
        captionMar: "Maroc",
      },
      servicesPreview: {
        eyebrow: "Ce que nous faisons",
        title: "Des services conçus pour franchir les frontières.",
        link: "Tous les services",
        items: [
          {
            title: "Internationalisation & Market Entry",
            short: "Entrée sur le marché, recherche de partenaires et soutien opérationnel sur place.",
          },
          {
            title: "Investor Relations",
            short: "Nous relions capitaux et projets dans les deux sens, avec un suivi constant.",
          },
          {
            title: "Relations institutionnelles & Networking",
            short: "Institutions, associations et communautés : le réseau qui ouvre les bonnes portes.",
          },
          {
            title: "Communication, Branding & Digital",
            short: "Identité, salons, réunions d'affaires et présence digitale pour les deux marchés.",
          },
        ],
      },
      teamPreview: {
        eyebrow: "L'équipe",
        title: "Trois profils, un seul pont.",
        link: "Découvrir l'équipe",
        text: "Trois associés, une seule mission : être sur le terrain, des deux côtés de la Méditerranée.",
      },
      data: {
        eyebrow: "Pourquoi l'Italie et le Maroc",
        title: "Deux pays qui ont tout intérêt à se regarder.",
        text: "Le savoir-faire et le design italiens rencontrent la croissance industrielle marocaine et sa position de porte vers les marchés africains. Les chiffres parlent d'eux-mêmes.",
        items: [
          { n: 5, suffix: " Mds €", l: "d'échanges commerciaux entre les deux pays (2024)" },
          { n: 1, suffix: "er", l: "exportateur automobile d'Afrique : le Maroc" },
          { n: 2, suffix: "e", l: "économie de l'Union européenne : l'Italie" },
          { n: 200, suffix: "+", l: "entreprises italiennes déjà actives au Maroc, avec plus de 13 800 salariés" },
          { n: 59, suffix: " mln", l: "de consommateurs en Italie" },
          { n: 38, suffix: " mln", l: "de consommateurs au Maroc" },
        ],
        source: "Sources : Observatoire économique MAECI — données ICE et Banque d'Italie (2024) · SACE",
      },
      map: {
        eyebrow: "Le corridor",
        title: "Deux pays, un seul corridor.",
        text: "Le réseau en Italie rencontre le siège au Maroc : un corridor unique pour les relations, les investissements et les projets.",
        labelIta: "Italie",
        labelMar: "Maroc",
        legendIta: "Réseau en Italie",
        legendMar: "Siège au Maroc",
      },
      cta: {
        title: "Prêt à traverser le pont ?",
        text: "Parlez-nous de votre projet : construisons ensemble la route entre l'Italie et le Maroc.",
        btn: "Aller aux contacts",
      },
    },
    services: {
      eyebrow: "Services",
      title: "Du premier appel au premier projet.",
      sub: "Cinq lignes de service, une seule méthode : mettre à table les bonnes personnes, dans les deux pays.",
      items: [
        {
          title: "Internationalisation & Market Entry",
          desc: "Nous accompagnons les entreprises dans leur processus d'expansion vers l'autre pays : analyse des opportunités, premier contact avec le marché, recherche de partenaires et de fournisseurs, soutien opérationnel sur place jusqu'à la stabilisation.",
        },
        {
          title: "Investor Relations",
          desc: "Accompagnement des investisseurs italiens intéressés au Maroc et des acteurs marocains visant l'Italie : présentation d'opportunités productives, rencontres avec les bons interlocuteurs et suivi constant des négociations.",
        },
        {
          title: "Relations institutionnelles & Networking",
          desc: "Grâce aux rôles institutionnels et associatifs des associés dans les deux pays, nous ouvrons les bonnes portes et construisons des alliances durables entre les deux systèmes pays.",
        },
        {
          title: "Communication, Branding & Digital",
          desc: "Identité de marque, communication interculturelle, réunions d'affaires et salons internationaux, sites web et outils digitaux développés sur mesure pour grandir sur les deux marchés.",
        },
        {
          title: "Médiation interculturelle & Communauté",
          desc: "Événements, projets de territoire, tourisme et relations publiques : le dialogue entre les communautés italiennes et marocaines avant — et avec — les contrats. Les personnes sont le premier actif de tout investissement.",
        },
      ],
      process: {
        eyebrow: "Notre méthode",
        title: "Une méthode en quatre étapes.",
        steps: [
          { n: "01", title: "Écoute", desc: "Objectifs, délais et contraintes de votre projet : partons de là où vous êtes." },
          { n: "02", title: "Analyse", desc: "Opportunités, contacts et territoire : nous traçons la carte des possibilités." },
          { n: "03", title: "Mise en relation", desc: "Nous relions les bonnes personnes, dans les deux pays." },
          { n: "04", title: "Accompagnement", desc: "Nous restons sur le terrain, jusqu'aux résultats et au-delà." },
        ],
      },
      note: "Chaque projet est différent : les lignes de service se combinent sur mesure.",
      cta: "Discutons de votre projet",
    },
    team: {
      eyebrow: "L'équipe",
      title: "Trois profils, un seul pont.",
      sub: "Des professionnels italo-marocains actifs en Italie et au Maroc, avec des rôles dans les institutions et les associations des deux pays.",
      labels: {
        education: "Formation",
        civic: "Engagement institutionnel et associatif",
        languages: "Langues",
        skills: "Compétences clés",
      },
      founders: [
        {
          id: "mohammed",
          initials: "MH",
          name: "Mohammed Hammouch",
          role: "Community Manager",
          bio: "Consultant stratégique dans le secteur de l'énergie et administrateur local engagé dans le développement du territoire et le dialogue interculturel. Né en 1990, professionnel freelance expérimenté en conseil énergétique et services multiples.",
          education: "Diplôme en Systèmes Énergétiques et Renouvelables",
          civic: [
            "Président de l'association GIM — Giovani Italo-Marocchini, association qui a bâti des liens institutionnels et culturels solides entre l'Italie et le Maroc",
            "Assesseur au Tourisme, au Commerce et à l'Environnement — Commune de Pieve di Soligo (TV)",
          ],
          languages: ["Italien", "Arabe", "Français", "Anglais"],
        },
        {
          id: "sana",
          initials: "SE",
          name: "Sana Ed Dami",
          role: "Investor Relations",
          bio: "Professionnelle de la communication et du branding, au parcours multiculturel et neuf ans d'expérience en entreprise. Experte dans l'organisation de réunions d'affaires et de salons internationaux : depuis 2024, storyteller officielle de l'UNESCO pour le site du Patrimoine mondial des Collines du Prosecco de Conegliano et Valdobbiadene.",
          education: "Diplôme en Sciences Politiques, Relations Internationales et Droits Humains — Université de Padoue · Erasmus, University of Reading (UK)",
          civic: [
            "Conseillère municipale et cheffe de groupe — Farra di Soligo (TV)",
            "Candidate au poste de maire en 2024",
          ],
          languages: ["Italien", "Arabe", "Anglais", "Français"],
        },
        {
          id: "wissam",
          initials: "WA",
          name: "Wissam El Aissaoui",
          role: "Morocco Relations",
          bio: "Web designer et facilitateur d'opportunités entre l'Italie et le Maroc. Né en 1998, professionnel freelance en communication digitale et développement web, fondateur de WEA Solution. Co-fondateur de SWM Consulting : il accompagne les entrepreneurs et investisseurs italiens dans leur internationalisation au Maroc.",
          education: "Diplôme commercial · Post-diplôme biennal en marketing touristique",
          civic: [
            "Conseiller municipal — Poviglio (RE)",
            "Vice-président de l'association GIM",
            "Président CNA Jeunes Entrepreneurs Reggio Emilia",
            "Président RNI Young Italy — section jeunesse du parti marocain RNI",
          ],
          languages: ["Italien", "Arabe", "Français", "Anglais"],
        },
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "Parlons de votre projet.",
      sub: "Un doute, une opportunité, un projet entre les deux pays ? Écrivez-nous : nous répondons en italien, arabe, français et anglais.",
      cards: [
        { label: "Email", value: "info@swmconsulting.it", href: "mailto:info@swmconsulting.it" },
        { label: "Sièges", value: "Rabat (Maroc) · Reggio Emilia et Trévise (Italie)" },
      ],
      form: {
        title: "Écrivez-nous",
        name: "Nom et prénom",
        namePlaceholder: "Jean Dupont",
        email: "Email",
        emailPlaceholder: "nom@entreprise.fr",
        org: "Organisation (facultatif)",
        orgPlaceholder: "Entreprise / Cabinet / Association",
        interest: "Intérêt",
        interestOptions: [
          "Internationalisation & Market Entry",
          "Investor Relations",
          "Relations institutionnelles & Networking",
          "Communication, Branding & Digital",
          "Médiation interculturelle & Communauté",
          "Autre",
        ],
        message: "Message",
        messagePlaceholder: "Parlez-nous brièvement de votre projet…",
        submit: "Envoyer le message",
        sending: "Envoi…",
        success: "Message envoyé ! Nous vous répondrons rapidement.",
        error: "Erreur lors de l'envoi. Réessayez.",
        required: "champs obligatoires",
      },
    },
    footer: {
      tagline: "Connecting Italy with Morocco",
      blurb: "Conseil pour les relations et les investissements entre l'Italie et le Maroc.",
      browse: "Naviguer",
      contact: "Contact",
      rights: "© SWM Consulting. Tous droits réservés.",
    },
  },
};
